import styled from "styled-components";

export const Container = styled.section`
    padding: 32px;
    min-height: calc(100vh - 78px);
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const ServiceHeader = styled.h4`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-size: 13px;
    text-align: center;
    & span {
        max-width: 120px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;